import React from 'react';
import PropTypes from 'prop-types';
import CeButtonNode from './ce-button-node';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {handleEvent} from '../../../../events/event-handler';

const getDataFromNode = function(node) {
    const keys = ['id', 'title', 'enabled', 'required', 'behavior', 'zIndex'];
    const nodeProps = filterNodeProperties(node, keys, {});
    nodeProps.enabled = nodeProps.enabled === '1';
    nodeProps.required = nodeProps.required === '1';
    return nodeProps;
};

class CeNode extends React.Component {

    constructor(props) {
        super(props);

        const ceButtonsList = this.props.node.childrenNamed('ce_button_node').reduce(
            (selected, n) => {
                return {...selected, [n.attr.id]: null};
            }, {}
        );

        const ceButtonsListHasBeenClicked = this.props.node.childrenNamed('ce_button_node').reduce(
            (selected, n) => {
                return {...selected, [n.attr.id]: false};
            }, {}
        );

        this.state = {
            ...getDataFromNode(props.node),
            visibleNodeKey: '',
            ceButtonsList,
            isCeButtonVisible: true,
            isTipVisible: false,
            selectedCeNodes: {},
            ceButtonsListHasBeenClicked
        };

        this.enableCE = this.enableCE.bind(this);
        this.enableTip = this.enableTip.bind(this);
        this.disableTip = this.disableTip.bind(this);
    }

    componentDidMount() {
        const {node : {attr : {title, required}}, disableJREAppPlayerContainerButtons } = this.props;
        const ceNodeIsRequired = title.toLowerCase() !== 'tip';
        if (ceNodeIsRequired && required === '1'){
            disableJREAppPlayerContainerButtons('requiredNodeNotCompleted', 'CeNode componentDidMount');
        }

        document.addEventListener('jre-ce-enabled', this.enableCE);
        document.addEventListener('jre-tip-enabled', this.enableTip);
        document.addEventListener('jre-audio-ended', this.enableCE);
        document.addEventListener('jre-video-ended', this.enableCE);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            selectedCeNodes: nextProps.selectedCeNodes
        });
    }

    componentWillUnmount() {
        const { enableJREAppPlayerContainerButtons } = this.props;
        enableJREAppPlayerContainerButtons('requiredNodeNotCompleted', 'CeNode componentWillUnmount');

        document.removeEventListener('jre-ce-enabled', this.enableCE);
        document.removeEventListener('jre-tip-enabled', this.enableTip);
        document.removeEventListener('jre-audio-ended', this.enableCE);
        document.removeEventListener('jre-video-ended', this.enableCE);
    }

    enableCE() { 
        
        //     const el = document.querySelectorAll('#overlayhides');
        // console.log(el);       
        // if(el != null){
        //    el.classList.remove("overlay-mask");          
        // }         
        const {behavior} = this.state;
        if(behavior === 'erase'){
            // when behavior === 'erase' we want to hide("close") the ce-button-node children when
            // jre-audio/video-ended and we do this by setting visibleNodeKey to null MOD-1502
            this.setState({visibleNodeKey: null});
        }
        this.setState({enabled: true});
        const el2 = document.querySelectorAll(".jre-tip");
        // console.log(el2);       
        // if(el != null){
        //    el.classList.remove("overlay-mask");          
        // }         

        if(el2 != null){          
            el2.forEach(function(element) {
        element.classList.remove("overlay-mask");
        });            
        } 
    }

    enableTip() {
        this.setState({enabled: true});
        this.setState({isTipVisible: true});
        // document.addEventListener('click', this.disableTip);
        // ceButtonsList.map(function(key, ceButton) {
        //     return {key: true};
        // });
        const el = document.querySelector('#overlayhides');
        if(el != null){
            el.classList.remove("overlay-mask");
        } 
        const el1 = document.querySelectorAll(".jre-tip");
        // console.log(el1);       
        // if(el != null){
        //    el.classList.remove("overlay-mask");          
        // }         

        if(el1 != null){          
            el1.forEach(function(element) {
        element.classList.remove("overlay-mask");
        });            
        }  
    }

    disableTip() {
        let { ceButtonsList = {}} = this.state;
        for (let id in ceButtonsList) {
            ceButtonsList[id] = false;
        }
        this.setState({
            isTipVisible: false,
            visibleNodeKey: null,
            ceButtonsList
        });        
    }

    displayButtonNode(node) {
        let { ceButtonsList = {}, behavior = 'normal', ceButtonsListHasBeenClicked={}, required} = this.state;
        const { enableJREAppPlayerContainerButtons } = this.props;
        const id = node.attr.id;
        const lastButtonState = ceButtonsList[id];
        const title = this.props.node.attr.title;

        this.props.onActiveCeNode(this.state.id);

        for (let id in ceButtonsList) { //
            if(ceButtonsList.hasOwnProperty(id)){
                ceButtonsList[id] = false;
            }
        }

        if (behavior === 'click' && title.toLowerCase() === 'tip') {
            ceButtonsList[id] = !lastButtonState;
            if (this.state.isTipVisible) {
                this.setState({isTipVisible: false});
            } else {
                this.enableTip();
            }
        } else {
            ceButtonsList[id] = true;
            ceButtonsListHasBeenClicked[id] = true;
        }

        const arrayOfClickedCeButtons = [];
        for (let id in ceButtonsListHasBeenClicked) {
            if(ceButtonsListHasBeenClicked.hasOwnProperty(id)){
                arrayOfClickedCeButtons.push(ceButtonsListHasBeenClicked[id]);
            }
        }
        const requiredCeNodeCompleted = arrayOfClickedCeButtons.every(clickedStatus => clickedStatus);
        if(requiredCeNodeCompleted && required){
            enableJREAppPlayerContainerButtons('requiredNodeNotCompleted', 'CeNode displayButtonNode');
        }

        this.setState({
            ceButtonsList,
            visibleNodeKey: ceButtonsList[id] === false ? null : id,
            /* There ara cases where the CE button will disappear when its clicked on. Currently, there is no
            better way to detect this behaviour other then checking the title, and it looks like we can't depend on the
            "enabled" and/or "required" attributes. */
            isCeButtonVisible: !(title.toLowerCase() === 'innovation station'
                || title.toLowerCase() === 'information station')
        });

        const eventList = node.children.filter(item => item.name === 'event_node');
        eventList.forEach(function(event) {
            if (event.attr.name === 'onclick') {
                handleEvent(event);
            }
        });
    }

    render() {
        const {title = '', enabled = false, required = false, behavior = 'normal',
            isCeButtonVisible = true, isTipVisible, visibleNodeKey, ceButtonsList, selectedCeNodes, id, } = this.state;
        const {moduleURL = '', enableJREAppPlayerContainerButtons, disableJREAppPlayerContainerButtons} = this.props;
        /* Initially, elements on the page will have z-index of 1. When we launch a CE (click event), the content that
        will appear needs to be above the existing content which will need a z-index of at least 2. On top of that,
        another element may appear on the page, in particular a "tip" item, and that will need a z-index of at least 3. */
        let zIndex;
        if (this.state.zIndex){
            zIndex = this.state.zIndex;
        } else {
            zIndex = this.props.node.attr.title.toLowerCase() === 'tip' ? 3 : 2;
        }

        return (
            <div>
                {(!this.state.isTipVisible && !this.state.enabled) ? <div className="overlay-mask"  id="overlayhides"/> : ''}
                {this.props.node.childrenNamed('ce_button_node').map(node =>
                {
                    let childZIndex = (node.attr.zIndex) ? node.attr.zIndex : zIndex;
                    return <CeButtonNode
                        onClick={this.displayButtonNode.bind(this, node)}
                        key={node.attr.id} node={node} required={required}
                        clearCeNodeContentView={this.props.clearCeNodeContentView}
                        selected={ceButtonsList[node.attr.id] && selectedCeNodes[id]}
                        childrenVisible={node.attr.id === visibleNodeKey && selectedCeNodes[id]}
                        zIndex={childZIndex}
                        enabled={enabled}
                        isCeButtonVisible={isCeButtonVisible}
                        moduleURL={moduleURL}
                        title={title}
                        isTipVisible={isTipVisible}
                        disableTip={this.disableTip}
                        behavior={behavior}
                        enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons} // needed for audio
                        // and video nodes nested within the CeButtonNode,
                        disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />;
                })}
            </div>
        );
    }
}

CeNode.propTypes = {
    node: PropTypes.object.isRequired
};

export default CeNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/ce-node.js